import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Timer, ChartLine, Users } from 'phosphor-react';
import './WelcomePage.css';

const WelcomePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="welcome-page">
      <div className="welcome-container">
        <header className="welcome-header">
          <h1>Simple Baby Sleep</h1>
          <p className="tagline">Just simple sleep hazzle-free sleep tracking.</p>
        </header>

        <section className="welcome-features">
          <div className="feature-item">
            <div className="feature-icon">
              <Timer size={32} weight="light" />
            </div>
            <h3>One-Tap Tracking</h3>
            <p>Start and stop sleep sessions with a single tap</p>
          </div>
          <div className="feature-item">
            <div className="feature-icon">
              <ChartLine size={32} weight="light" />
            </div>
            <h3>View Patterns</h3>
            <p>Understand your baby's sleep habits and trends</p>
          </div>
          <div className="feature-item">
            <div className="feature-icon">
              <Users size={32} weight="light" />
            </div>
            <h3>Share with Partner</h3>
            <p>Sync tracking across devices in real-time</p>
          </div>
        </section>

        <div className="welcome-cta">
          <button
            className="get-started-btn"
            onClick={() => navigate('/get-started')}
          >
            Get Started
          </button>
        </div>

        <div className="welcome-signin">
          <p>Already have an account? <Link to="/signin">Sign in</Link></p>
        </div>

        <footer className="welcome-footer">
          <p>Simple sleep tracking for parents</p>
          <div className="welcome-footer-links">
            <Link to="/privacy">Privacy Policy</Link>
            <span className="footer-separator">•</span>
            <Link to="/support">Support</Link>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default WelcomePage;
